import React from 'react';
import { ApimPageShell } from '@pages/api-portal/apim-page-shell';
import { useCatalog } from './use-catalog';
import { CatalogFiltersAside } from './filters-aside';
import { ActiveFilterChips } from './active-filter-chips';
import { MainColumn } from './main-column';

/*
 * API Catalog browse screen — search/filter panel plus a grouped, expandable list of
 * documented endpoints.
 */
export function CatalogScreen() {
    const {
        apiGroups,
        allEndpoints,
        isLoading,
        catalogFetchFailed,
        retryCatalogFetch,
        searchQuery,
        setSearchQuery,
        selectedGroup,
        applyGroupFilter,
        selectedMethods,
        setSelectedMethods,
        selectedVersions,
        setSelectedVersions,
        selectedStatuses,
        setSelectedStatuses,
        expandedGroups,
        toggleGroup,
        toggleFilterOption,
        clearFilters,
        hasActiveFilters,
        filteredEndpoints,
        groupedEndpoints,
    } = useCatalog();

    return (
        <ApimPageShell navSelectedId="apim" navType="others">
            <header>
                <h1>
                    <img src="/icons/code.png" alt="" width={28} height={28} />
                    API Catalog
                </h1>
            </header>
            <div style={{ display: 'flex' }}>
                <CatalogFiltersAside
                    apiGroups={apiGroups}
                    allEndpoints={allEndpoints}
                    selectedGroup={selectedGroup}
                    onApplyGroupFilter={applyGroupFilter}
                    selectedMethods={selectedMethods}
                    onToggleMethod={(value) => toggleFilterOption(value, selectedMethods, setSelectedMethods)}
                    selectedVersions={selectedVersions}
                    onToggleVersion={(value) => toggleFilterOption(value, selectedVersions, setSelectedVersions)}
                    selectedStatuses={selectedStatuses}
                    onToggleStatus={(value) => toggleFilterOption(value, selectedStatuses, setSelectedStatuses)}
                    hasActiveFilters={hasActiveFilters}
                    onClearFilters={clearFilters}
                />
                <div style={{ flex: 1 }}>
                    <div style={{ padding: '16px 16px 0' }}>
                        <ActiveFilterChips
                            selectedGroup={selectedGroup}
                            onClearGroup={() => applyGroupFilter(null)}
                            selectedMethods={selectedMethods}
                            onRemoveMethod={(value) => toggleFilterOption(value, selectedMethods, setSelectedMethods)}
                            selectedVersions={selectedVersions}
                            onRemoveVersion={(value) => toggleFilterOption(value, selectedVersions, setSelectedVersions)}
                            selectedStatuses={selectedStatuses}
                            onRemoveStatus={(value) => toggleFilterOption(value, selectedStatuses, setSelectedStatuses)}
                        />
                    </div>
                    <MainColumn
                        isLoading={isLoading}
                        catalogFetchFailed={catalogFetchFailed}
                        onRetry={retryCatalogFetch}
                        searchQuery={searchQuery}
                        onSearchChange={setSearchQuery}
                        totalCount={allEndpoints.length}
                        filteredCount={filteredEndpoints.length}
                        groupedEndpoints={groupedEndpoints}
                        apiGroups={apiGroups}
                        expandedGroups={expandedGroups}
                        onToggleGroup={toggleGroup}
                    />
                </div>
            </div>
        </ApimPageShell>
    );
}
